import useTableOfContents from '../../../src/client/cms/utils/use-table-of-contents';

type UseGetTableOfContentsListsParams = {
  fragment: string;
  shouldSkip: boolean;
  slug: string;
};

const useGetTableOfContentsLists = ({ fragment, shouldSkip, slug }: UseGetTableOfContentsListsParams) => {
  const { items, error, loading } = useTableOfContents({
    fragment,
    skip: shouldSkip,
    slug,
  });

  return { data: items, error, loading };
};

export default useGetTableOfContentsLists;
